import { useEffect, useMemo } from 'react'
import AccountAccessLoginOTP from 'components/Account/AccountAccess/AccountAccessLoginOTP'
import ModalBase from 'LuxKit/Modal/ModalBase'
import { sendOTPVerificationCode } from 'actions/AuthActions'
import { useAppDispatch } from 'hooks/reduxHooks'

interface Props {
  email: string
  maskedPhone: string
}

export default function LesaOTPModal({ email, maskedPhone }: Props) {
  const dispatch = useAppDispatch()

  const user = useMemo<App.User>(() => ({ email, maskedPhone }), [email, maskedPhone])

  useEffect(() => {
    dispatch(sendOTPVerificationCode(user))
  }, [dispatch, user])

  return (
    <ModalBase
      size="S"
      dismissible
    >
      <AccountAccessLoginOTP user={user} />
    </ModalBase>
  )
}
